import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useMemo,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  openModal,
  stockSummaryItemVoucherList,
} from "../../../../redux/actions/action-creator";
import TableLayoutItem from "../../../../components/Table/TableLayoutItem";
import NavLayout from "../../../../components/NavNameOfComponent/NavLayout";
import Period from "../../../../components/help/stock_summary/stock_summary_component/Period";
import ChangeView from "../../../../components/help/stock_summary/stockitemsummary/ChangeView";
import GodownFilter from "../../../../components/help/stock_summary/stockitemsummary/GodownFilter";
import StockItemVoucherFooter from "../../../../components/Footer/StockItemVoucherFooter";
import StockItemVoucherHelp from "../../../../components/help/stock_summary/StockItemVoucher/StockItemVoucherHelp";
import StockItemFilter from "../../../../components/help/stock_summary/StockItemVoucher/StockItemFilter";
import {
  currencyFormate,
  dateFormateShow,
  dateFormateSend,
} from "../../../../components/Date_Formate_Utilitiy/Index";
import "../../../../components/Table/tablelayoutItem.css";
import { useDropdownScroll } from "../../../../components/Custom_Hooks/useDropdownScroll";
import { useDropdownKeyboardNavigation } from "../../../../components/Custom_Hooks/useDropdownKeyboardNavigation";

const StockItemVoucher = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const boxRef = useRef(null);

  const { company_session } = useSelector((state) => state.common);
  const { userData } = useSelector((state) => state.auth);
  const modal_state = useSelector((state) => state.common.modal_state);

  const [loading, setLoading] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);
  const [removedItems, setRemovedItems] = useState([]);
  const [data, setData] = useState([]);

  const initialDate = useMemo(
    () => ({
      send_from_date: dateFormateSend(company_session?.start_financial_year),
      send_to_date: dateFormateSend(company_session?.current_date),
      location_id: "",
      filter_name: "Item-Wise",
      name_nav: ``,
    }),
    [company_session]
  );

  const [date, setDate] = useState(initialDate);
  // Memoized function to avoid unnecessary re-renders
  const fetchData = useCallback(async () => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("company_id", userData?.id);
    formdata.append("fromDate", dateFormateSend(date?.send_from_date));
    formdata.append("toDate", dateFormateSend(date?.send_to_date));
    formdata.append("location_id", date?.location_id);
    formdata.append("item_id", id);

    try {
      const response = await dispatch(stockSummaryItemVoucherList(formdata));
      if (response.status) {
        toast.success(response?.message || "Stock Summary Item !", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        setData(response.data);
      } else {
        toast.warn(response?.message || "Stock Summary Item !", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error("Failed to fetch Stock Summary Item!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setLoading(false);
    }
  }, [date, id, dispatch, userData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  //   const repeatedItems = useMemo(() => {
  //     if (!data?.voucher_item_data) return [];
  //     return Array.from({ length: 50 }).flatMap((_, i) =>
  //       data.voucher_item_data.map((item, j) => ({
  //         ...item,
  //         __originalIndex: j,
  //         __globalIndex: i * data.voucher_item_data.length + j,
  //       }))
  //     );
  //   }, [data?.voucher_item_data]);

  let qtyNum = data?.opening_data?.quantity?.match(/\d+/g) || 0;
  let qtyUnitName = data?.opening_data?.quantity?.match(/[a-z]+/gi) || 0;
  let cumulativeQuntity = parseFloat(qtyNum) || 0;
  let cumulativeRate = parseFloat(data?.opening_data?.rate) || 0;
  let closing_rate;
  let count = 1;

  const { selectedItemIndex, setSelectedItemIndex } =
    useDropdownKeyboardNavigation({
      items: data?.voucher_item_data,
      state:
        modal_state?.period ||
        modal_state?.stock_item ||
        modal_state?.change_view ||
        modal_state?.godown_wise
          ? false
          : true,
      onItemSelect: (item) => {
        // navigate(`../stock_item_voucher/${item?.stock_item_id}`);
        navigate(
          `../stock_item_voucher/${item.grandOpeningData.stock_item_id}`
        );
      },
      onItemSpaceSelect: (item) => {
        toggleSelection(selectedItemIndex);
      },
      onItemAltRSelect: (item) => {
        removeSelectedItems();
      },
      onItemAltUSelect: (item) => {
        restoreSelectedItems();
      },
      onItemF2Select: (item) => {
        dispatch(openModal("period"));
      },
      // onItemF4Select: (item) => {
      //   navigate('/ledgerbook')
      // },
      onItemF12Select: (item) => {
        dispatch(openModal("configure"));
      },
    });

  useDropdownScroll({ dropdownRef: boxRef, selectedItemIndex });

  // Function to toggle selection of an item
  const toggleSelection = (index) => {
    const selectedIndex = selectedItems.indexOf(index);
    let newSelected = [];
    if (selectedIndex === -1) {
      // Add the item to the selection if not already selected
      newSelected = newSelected.concat(selectedItems, index);
    } else if (selectedIndex === 0) {
      // Remove the item from the selection if already selected
      newSelected = newSelected.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelected = newSelected.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1)
      );
    }
    setSelectedItems(newSelected);
  };

  // Function to remove selected items
  const removeSelectedItems = () => {
    // If multiple items are selected, remove all selected items
    if (selectedItems.length > 0) {
      const selectedIndices = [...selectedItems].sort((a, b) => a - b); // Sort in ascending order
      const removedItemsList = [];

      // Collect all items to be removed
      selectedIndices.forEach((index) => {
        removedItemsList.push({
          index: index,
          item: data[index],
        });
      });

      // Filter out selected items from the list
      const updatedData = data?.filter((_, index) => {
        return !selectedIndices.includes(index);
      });

      // Recalculate totals
      // let current_debit_total_amount = 0;
      // let current_credit_total_amount = 0;
      // updatedData.forEach((item) => {
      //   current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
      //   current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
      // });

      // setState({
      //   ...state,
      //   total_credit_amount: current_credit_total_amount,
      //   total_debit_amount: current_debit_total_amount,
      // });
      setData(updatedData);
      setRemovedItems([...removedItems, ...removedItemsList]);
      setSelectedItems([]); // Clear selection after removal
    } else {
      // If no multi-selection, remove single selected item
      const updatedData = data.voucher_item_data?.filter((_, index) => {
        return index !== selectedItemIndex;
      });

      const removedItem = data.voucher_item_data[selectedItemIndex];

      // let current_debit_total_amount = 0;
      // let current_credit_total_amount = 0;
      // updatedData.forEach((item) => {
      //   current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
      //   current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
      // });

      // setState({
      //   ...state,
      //   total_credit_amount: current_credit_total_amount,
      //   total_debit_amount: current_debit_total_amount,
      // });
      setData({ ...data, voucher_item_data: updatedData });
      setRemovedItems([
        ...removedItems,
        { index: selectedItemIndex, item: removedItem },
      ]);
    }
  };

  // Function to restore selected items
  const restoreSelectedItems = () => {
    if (removedItems.length === 0) {
      return; // No items to restore
    }

    // Restore the last removed item (LIFO - Last In, First Out)
    const lastRemovedItem = removedItems[removedItems.length - 1];
    const { index: originalIndex, item } = lastRemovedItem;

    // Find the correct position to insert the item back
    // We need to count how many items were removed before this one
    let insertIndex = originalIndex;
    const itemsRemovedBefore = removedItems.filter(
      (removedItem) => removedItem.index < originalIndex
    ).length;

    // Adjust the insert index based on how many items were removed before this one
    insertIndex = originalIndex - itemsRemovedBefore;

    // Create updated voucher entry list with the restored item at the correct position
    const updatedData = [
      ...data.voucher_item_data?.slice(0, insertIndex),
      item,
      ...data.voucher_item_data?.slice(insertIndex),
    ];

    /* const updatedData = {
        ...data,
        updatedData,
      }; */

    // Recalculate totals
    // let current_debit_total_amount = 0;
    // let current_credit_total_amount = 0;
    // updatedVoucherEntryList.forEach((item) => {
    //   current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
    //   current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
    // });

    // setState({
    //   ...state,
    //   total_credit_amount: current_credit_total_amount,
    //   total_debit_amount: current_debit_total_amount,
    // });
    setData({ ...data, voucher_item_data: updatedData });

    // Set the restored item as the selected item to show visual indication
    setSelectedItemIndex(insertIndex);

    // Remove the restored item from removedItems array
    setRemovedItems(removedItems.slice(0, -1));
  };

  const handleZeroValue = (value) => {
    let zeroValue = parseFloat(value);
    if (zeroValue === 0) {
      return null;
    }
    return currencyFormate(zeroValue);
  };

  // Calculate totals using useMemo to ensure proper calculation
  const totals = useMemo(() => {
    let total_inwards_quantity = 0;
    let total_outwards_quantity = 0;
    let total_closing_quantity = 0;
    let total_inwards_value = 0;
    let total_outwards_value = 0;
    let total_closing_value = 0;

    if (data?.voucher_item_data) {
      // Initialize with opening balance
      const openingQty = parseFloat(data?.opening_data?.quantity?.match(/\d+/g)) || 0;
      const openingValue = parseFloat(data?.opening_data?.value) || 0;
      
      let running_quantity = openingQty;
      let running_value = openingValue;
      let cumulative_rate = 0;
      let count = 0;

      data.voucher_item_data.forEach((item) => {
        let item_iw_qty = parseFloat(item?.inwardData?.quantity?.match(/\d+/g)) || 0;
        let item_iw_value = parseFloat(item?.inwardData?.value?.match(/\d+/g)) || 0;
        let item_iw_rate = parseFloat(item?.inwardData?.rate?.match(/\d+/g)) || 0;
        let item_Ow_qty = parseFloat(item?.outwardData?.quantity?.match(/\d+/g)) || 0;
        let item_Ow_value = parseFloat(item?.outwardData?.value?.match(/\d+/g)) || 0;

        // Accumulate totals
        total_inwards_quantity += item_iw_qty;
        total_outwards_quantity += item_Ow_qty;
        total_inwards_value += item_iw_value;
        total_outwards_value += item_Ow_value;

        // Update running balance
        if (item_iw_qty > 0) {
          running_quantity += item_iw_qty;
          cumulative_rate += item_iw_rate;
          count++;
        }
        if (item_Ow_qty > 0) {
          running_quantity -= item_Ow_qty;
        }

        // If we have quantity, use quantity-based calculation, otherwise use value
        if (item_iw_qty > 0 || item_Ow_qty > 0) {
          // Use quantity-based calculation
          running_value = running_quantity * (cumulative_rate / Math.max(count, 1));
        } else {
          // Use value-based calculation
          running_value += item_iw_value - item_Ow_value;
        }
      });

      total_closing_quantity = running_quantity;
      total_closing_value = running_value;
    }

    return {
      total_inwards_quantity,
      total_outwards_quantity,
      total_closing_quantity,
      total_inwards_value,
      total_outwards_value,
      total_closing_value
    };
  }, [data]);

  console.log("Calculated totals:", totals);
  return (
    <div className="section">
      <div className="detail">
        {modal_state?.show_period ? (
          <Period setDate={setDate} date={date} setLoading={setLoading} />
        ) : null}
        {modal_state?.show_stock_item ? (
          <StockItemFilter
            setDate={setDate}
            date={date}
            setLoading={setLoading}
          />
        ) : null}
        {modal_state?.show_change_view ? (
          <ChangeView setDate={setDate} date={date} />
        ) : null}
        {modal_state?.show_godown_wise ? (
          <GodownFilter date={date} setDate={setDate} />
        ) : null}
        <div className="container-fluid">
          <NavLayout>
            Stock Item Vouchers : {data?.stock_item_name} : {date?.name_nav}{" "}
            <span>{`${
              dateFormateShow(date?.send_from_date) === "NaN"
                ? null
                : dateFormateShow(date?.send_from_date)
            } To ${
              dateFormateShow(date?.send_to_date) === "NaN"
                ? null
                : dateFormateShow(date?.send_to_date)
            }`}</span>
          </NavLayout>
        </div>
        <TableLayoutItem
          total_inwards_quantity={totals.total_inwards_quantity}
          total_outwards_quantity={totals.total_outwards_quantity}
          total_closing_quantity={totals.total_closing_quantity}
          total_inwards_value={totals.total_inwards_value}
          total_outwards_value={totals.total_outwards_value}
          total_closing_value={totals.total_closing_value}
          ref={boxRef}
        >
          <div style={{ width: "100%" }} className={`custom_row_item`}>
            <div
              style={{ width: "7%" }}
              className="col-2 m-0 p-0 pe-1 text-end table_body_font"
            >
              {dateFormateShow(data?.opening_date)}
            </div>
            <div
              style={{ width: "24%" }}
              className="col-6 m-0 p-0 ps-1 table_body_font text-start"
            >
              {" "}
              Opening Balance
            </div>
            <div
              style={{ width: "8%" }}
              className="col-2 m-0 p-0 text-start table_body_font"
            ></div>
            <div
              style={{ width: "10%" }}
              className="col-2 m-0 p-0 text-end table_body_font"
            ></div>

            <div style={{ width: "17%" }} className="col-4  m-0 p-0">
              <div className="row m-0 p-0" style={{ width: "100%" }}>
                <div
                  className="col-4 text-end p-0 m-0 table_body_font"
                  style={{ overflow: "hidden", whiteSpace: "nowrap" }}
                >
                  {handleZeroValue(data?.opening_data?.quantity)}
                </div>
                <div
                  className="col-3 m-0 p-0 text-end table_body_font"
                  style={{ overflow: "hidden" }}
                >
                  {handleZeroValue(data?.opening_data?.rate)}
                </div>
                <div
                  className="col-5 text-end p-0 m-0 pe-1 table_body_font"
                  style={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    wordSpacing: -7,
                  }}
                >
                  {parseFloat(data?.opening_data?.value) === 0
                    ? null
                    : currencyFormate(parseFloat(data?.opening_data?.value))}
                </div>
              </div>
            </div>
            <div style={{ width: "17%" }} className="col-4  m-0 p-0">
              <div className="row m-0 p-0" style={{ width: "100%" }}>
                <div className="col-4 text-end p-0 m-0 table_body_font">
                  {/* {parseFloat(data?.opening_data?.quantity)} */}
                </div>
                <div className="col-3 m-0 p-0 text-end table_body_font">
                  {/* {currencyFormate(data?.opening_data?.rate)} */}
                </div>
                <div className="col-5 text-end p-0 pe-1 m-0 table_body_font">
                  {/* {currencyFormate(data?.opening_data?.value)} */}
                </div>
              </div>
            </div>

            <div style={{ width: "17%" }} className="col-4  m-0 p-0">
              <div className="row m-0 p-0" style={{ width: "100%" }}>
                <div className="col-4 text-end p-0 m-0 table_body_font">
                  {handleZeroValue(data?.closing_data?.quantity)}
                </div>
                <div className="col-3 text-end m-0 p-0 table_body_font">
                  {handleZeroValue(data?.closing_data?.rate)}
                </div>
                <div className="col-5 text-end p-0 pe-1 m-0 table_body_font">
                  {handleZeroValue(data?.closing_data?.value)}
                </div>
              </div>
            </div>
          </div>
          {data?.voucher_item_data?.map((item, index) => {
            let item_iw_qty = parseFloat(
              item?.inwardData?.quantity?.match(/\d+/g)
            ) || 0;
            let item_iw_rate = parseFloat(
              item?.inwardData?.rate?.match(/\d+/g)
            ) || 0;
            let item_iw_value = parseFloat(
              item?.inwardData?.value?.match(/\d+/g)
            ) || 0;
            let item_Ow_qty = parseFloat(
              item?.outwardData?.quantity?.match(/\d+/g)
            ) || 0;
            let item_Ow_value = parseFloat(
              item?.outwardData?.value?.match(/\d+/g)
            ) || 0;

            // Calculate cumulative values for this row
            count += item?.inwardData.length === 0 ? 0 : 1;
            cumulativeQuntity += item_iw_qty;
            cumulativeRate += item_iw_rate;
            closing_rate = cumulativeRate / parseFloat(count);
            cumulativeQuntity -= item_Ow_qty;

            // Calculate closing balance for this row
            let closing_quantity = cumulativeQuntity;
            let closing_rate_for_row = closing_rate;
            let closing_value = closing_quantity * closing_rate_for_row;

            // If we have quantity, use quantity-based calculation, otherwise use value
            if (item_iw_qty > 0 || item_Ow_qty > 0) {
              // Use quantity-based calculation
              closing_value = closing_quantity * closing_rate_for_row;
            } else {
              // Use value-based calculation
              closing_value = (cumulativeQuntity * closing_rate_for_row);
            }
            return (
              <div
                key={index}
                className={
                  selectedItems.includes(index) ? "selected_multi" : ""
                }
              >
                <div
                  style={{ cursor: "pointer", width: "100%" }}
                  className={`custom_row_item ${
                    index === selectedItemIndex
                      ? selectedItems.includes(index)
                        ? "selected_multi_selected"
                        : "selected"
                      : ""
                  }`}
                >
                  <div
                    style={{ width: "7%" }}
                    className="col-2 m-0 p-0 pe-1 text-end table_body_font"
                  >
                    {dateFormateShow(item?.create_date)}
                    {/* 03-Aug-2025 */}
                  </div>
                  <div
                    style={{ width: "24%" }}
                    className="col-6 m-0 p-0 ps-1 table_body_font text-start"
                  >
                    {" "}
                    {item?.party_ledger_name}
                  </div>
                  <div
                    style={{ width: "8%" }}
                    className="col-2 m-0 p-0 text-start table_body_font"
                  >
                    {item?.voucher_type_name}
                    {/* Purchase Return */}
                  </div>
                  <div
                    style={{ width: "10%" }}
                    className="col-2 m-0 p-0 pe-1 text-end table_body_font"
                  >
                    {item?.serial_no}
                    {/* 242348W451100003  */}
                  </div>

                  <div style={{ width: "17%" }} className="col-4  m-0 p-0">
                    <div className="row m-0 p-0" style={{ width: "100%" }}>
                      <div
                        className="col-4 text-end p-0 m-0 table_body_font"
                        style={{ overflow: "hidden", whiteSpace: "nowrap" }}
                      >
                        {handleZeroValue(item?.inwardData?.quantity)}
                        {/* 1,000.00 Box */}
                      </div>
                      <div
                        className="col-3 m-0 p-0 text-end table_body_font"
                        style={{ overflow: "hidden" }}
                      >
                        {handleZeroValue(item?.inwardData?.rate)}
                      </div>
                      <div
                        className="col-5 text-end p-0 m-0 pe-1 table_body_font"
                        style={{
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          wordSpacing: -7,
                        }}
                      >
                        {handleZeroValue(item?.inwardData?.value)}
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "17%" }} className="col-4  m-0 p-0">
                    <div className="row m-0 p-0" style={{ width: "100%" }}>
                      <div className="col-4 text-end p-0 m-0 table_body_font">
                        {handleZeroValue(item?.outwardData?.quantity)}
                      </div>
                      <div className="col-3 m-0 p-0 text-end table_body_font">
                        {handleZeroValue(item?.outwardData?.rate)}
                      </div>
                      <div className="col-5 text-end p-0 pe-1 m-0 table_body_font">
                        {handleZeroValue(item?.outwardData?.value)}
                      </div>
                    </div>
                  </div>

                  <div style={{ width: "17%" }} className="col-4  m-0 p-0">
                    <div className="row m-0 p-0" style={{ width: "100%" }}>
                      <div className="col-4 text-end p-0 m-0 table_body_font">
                        {handleZeroValue(closing_quantity)}
                      </div>
                      <div className="col-3 text-end m-0 p-0 table_body_font">
                        {handleZeroValue(closing_rate_for_row)}
                      </div>
                      <div className="col-5 text-end p-0 pe-1 m-0 table_body_font">
                        {handleZeroValue(closing_value)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </TableLayoutItem>
        <StockItemVoucherFooter
          isDisable={removedItems.length === 0}
          spaceFunction={() => toggleSelection(selectedItemIndex)}
          removeLineFunction={() => removeSelectedItems()}
          restoreLineFunction={() => restoreSelectedItems()}
        />
      </div>
      <div className="help border_1_1px_left backgroud_color_1 position-relative">
        {modal_state?.show_period ||
        modal_state?.show_stock_item ||
        modal_state?.show_change_view ||
        modal_state?.show_godown_wise ? null : (
          <StockItemVoucherHelp />
        )}
      </div>
    </div>
  );
};

export default StockItemVoucher;
